import Vue from 'vue';
import ModalBase from "./views/ModalBase.vue";
import { OverlayManager } from "../overlay-manager.js";

class ModalManager {
  static base = [];
  static open(options) {
      let promiseRes = {};
      let closePromise = new Promise((resolve, reject) => {
        promiseRes.resolve = resolve;
        promiseRes.reject = reject;
      });
      this.show(options, promiseRes);
      return closePromise;
  }
  static show(options, promiseRes) {
    let modalBase = Vue.extend(ModalBase)
    let modal = new modalBase({
      parent: OverlayManager.getOverlayBase(),
      propsData: {
        ...options,
        promiseRes: promiseRes
      }
    });
    
    this.base.push(modal.$mount());
  }
  static close(id) {
    this.base = this.base.filter((modal) => {
      if (modal.id == id) {
        modal.$destroy();
        OverlayManager.close(id);
        return false;
      }
      return true;
    });
  }
}

export default ModalManager;
